import { createStore, compose } from 'redux'
import rootReducer from './reducer'
import { reactReduxFirebase } from 'react-redux-firebase'
import * as firebase from 'firebase'

const fbConfig = {
  apiKey: "AIzaSyCu8OOeL9rQ1Bbl_eLuzydCpoYqmzxVvg8",
  authDomain: "pristine-website.firebaseapp.com",
  databaseURL: "https://pristine-website.firebaseio.com",
  projectId: "pristine-website",
  storageBucket: "pristine-website.appspot.com",
  messagingSenderId: "340478275560"
}
firebase.initializeApp(fbConfig)

const config = {
  userProfile: 'admins',
}

export default function configureStore (initialState) {
  const createStoreWithMiddleware = compose(
    reactReduxFirebase(firebase, config)
  )(createStore)
  const store = createStoreWithMiddleware(rootReducer)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducer', () => {
      const nextRootReducer = require('./reducer')
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}


// WEBPACK FOOTER //
// ./src/store.js